import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { ProjectFileCategoryEnum, ProjectFileKindEnum, ProjectFileVisibilityEnum } from '../generated/types';
import { PROJECT_FILES_QUERY } from './useProjectFiles';

const UPLOAD_PROJECT_FILE_MUTATION = gql`
  mutation UploadProjectFile(
    $projectId: ID!
    $name: String!
    $description: String
    $fileType: ProjectFileKindEnum!
    $category: ProjectFileCategoryEnum!
    $visibility: ProjectFileVisibilityEnum
    $diaryEntryId: ID
    $folder: String
    $version: String
    $attachment: Upload!
  ) {
    uploadProjectFile(
      projectId: $projectId
      name: $name
      description: $description
      fileType: $fileType
      category: $category
      visibility: $visibility
      diaryEntryId: $diaryEntryId
      folder: $folder
      version: $version
      attachment: $attachment
    ) {
      projectFile {
        id
        name
      }
    }
  }
`;

export interface UploadProjectFileInput {
  projectId: string;
  name: string;
  description?: string;
  fileType: ProjectFileKindEnum;
  category: ProjectFileCategoryEnum;
  visibility?: ProjectFileVisibilityEnum;
  diaryEntryId?: string;
  folder?: string;
  version?: string;
  attachment: File;
}

export function useUploadProjectFile(projectId: string) {
  const [uploadMutation, { loading, error }] = useMutation(UPLOAD_PROJECT_FILE_MUTATION, {
    refetchQueries: [{ query: PROJECT_FILES_QUERY, variables: { projectId } }],
  });

  const uploadProjectFile = async (input: UploadProjectFileInput) => {
    const { data } = await uploadMutation({
      variables: {
        projectId: input.projectId,
        name: input.name,
        description: input.description ?? null,
        fileType: input.fileType,
        category: input.category,
        visibility: input.visibility ?? null,
        diaryEntryId: input.diaryEntryId ?? null,
        folder: input.folder ?? null,
        version: input.version ?? null,
        attachment: input.attachment,
      },
    });
    return (data as { uploadProjectFile: { projectFile: { id: string; name: string } } }).uploadProjectFile.projectFile;
  };

  return { uploadProjectFile, loading, error };
}
